$(document).ready(function() {
    const orderGuest = {
        isLoadingInfo: false,
        init() {
            $(document).on('click', '.guest-billing-tab', this, this.billingTab);
            $(document).on('change', '#copy_shipping_data', this, this.copyShppingData);
            $(document).on('click', '.payment-method-btn', this, this.selectPaymentMethod);
            $(document).on('click', '.shipping-method-btn', this, this.selectShippingMethod);
            $(document).on('change', '#create_account', function() {
				if ($('#create_account').is(':checked')) {
					$('#create-account-container').show();
				} else {
					$('#create-account-container').hide();
				}
			});

			$(document).on('change', '#billing-county_id', this, this.getBillingCities);
			$(document).on('change', '#company-county', this, this.getCompanyCities);
			$(document).on('change', '#shipping-county_id', this, this.getCities);

			$(document).on('change', '#shipping-city_id', this, this.getShippingFee);

			$(document).on('change', '#wants_invoice', this, function() {
				if ($('#wants_invoice').is(':checked')) {
					$('#order-billing-container').show();
					$('#billing-county_id').select2();
					$('#billing-city_id').select2();
				} else {
					$('#order-billing-container').hide();
				}
			});
        },
		getShippingFee() {
			var values = '_token=' + $("meta[name='csrf-token']").attr("content");
			values += '&city_id=' + $('#shipping-city_id').val();
			values += '&shipping_method=' + $('#shipping_method').val();
			values += '&person_type=' + $('#person_type').val();
			$.ajax({
				type: "POST",
				url: baseURL + "/checkout/shipping-fee",
				data: values,
				success: function(response) {
					if (response.status == 1) {
						$('.shipping-amount').text(response.shipping_amount > 0 ? response.shipping_amount + ' LEI' : 'Gratuit');
						$('.order-total').text(response.total + ' LEI');
						$('.amount-to-free-shipping').text('Adauga produse de inca '+response.amount_to_free_shipping+' lei si ai transport gratuit');
						if (response.amount_to_free_shipping < 1) {
							$('.amount-to-free-shipping').hide();
						} else {
							$('.amount-to-free-shipping').show();
						}
					}
				},
				error(error) {

				}
			});
		},
		getVat() {
			var values = '_token=' + $("meta[name='csrf-token']").attr("content");
			values += '&person_type=' + $('#person_type').val();
			$.ajax({
				type: "POST",
				url: baseURL + "/checkout/vat",
				data: values,
				success: function(response) {
					if (response.status == 1) {
						$('.order-total').text(response.total + ' LEI');
						$('.vat-value').text(response.vat_value);
						$('.vat-amount').text(response.vat_amount + ' LEI');
					}
				},
				error(error) {

				}
			});
		},
		copyShppingData() {
			if ($('#copy_shipping_data').is(':checked')) {
				$('#billing-first-name').val($('#shipping-first-name').val());
				$('#billing-last-name').val($('#shipping-last-name').val());
				$('#billing-phone').val($('#shipping-phone').val());
				$('#billing-email').val($('#shipping-email').val());
				$('#billing-county_id').val($('#shipping-county_id option:selected').val()).trigger('change');
				$('#billing-city_id').val($('#shipping-city_id option:selected').val()).trigger('change');
				$('#billing-address').val($('#shipping-address').val());
			} else {
				$('#billing-first-name').val('');
				$('#billing-last-name').val('');
				$('#billing-phone').val('');
				$('#billing-email').val('');
				$('#billing-county_id').val('').trigger('change');
				$('#billing-city_id').val('').trigger('change');
				$('#billing-address').val('');
			}
		},
		selectShippingMethod(event) {
			const _this = event.data;
			$('#shipping-methods-wrapper').find('.shipping-method').removeClass('active');
			var id = $(this).data('id');
			$('#shipping-method-' + id).addClass('active');
			$('#shipping_method').val(id);

			_this.getShippingFee();
		},
		selectPaymentMethod() {
			$('#payment-methods-wrapper').find('.payment-method').removeClass('active');
			var id = $(this).data('id');
			$('#payment-method-' + id).addClass('active');
			$('#payment_method').val(id);
		},
		billingTab(event) {
			const _this = event.data;
			
			$('#person_type').val($(this).data('person-type'));
			$('#billing-county_id').select2();
			$('#billing-city_id').select2();
			$('#company_country_id').select2();

			_this.getVat();
        },
		getCities() {
			$('#shipping-city_id').find('option:not(:first)').remove();
			let cities = $('#shipping-county_id option:selected').data('cities');
			cities = Object.keys(cities).map(key => {
			    return cities[key];
			});
			for (var i in cities) {
				$('#shipping-city_id').append('<option value="'+cities[i].id+'">'+cities[i].name+'</option>');
			}
        },
		getBillingCities() {
			$('#billing-city_id').find('option:not(:first)').remove();
			let cities = $('#billing-county_id option:selected').data('cities');
			cities = Object.keys(cities).map(key => {
			    return cities[key];
			});
			for (var i in cities) {
				$('#billing-city_id').append('<option value="'+cities[i].id+'">'+cities[i].name+'</option>');
			}
        },
		getCompanyCities() {
			$('#company-city').find('option:not(:first)').remove();
			let cities = $('#company-county option:selected').data('cities');
			cities = Object.keys(cities).map(key => {
			    return cities[key];
			});
			for (var i in cities) {
				$('#company-city').append('<option value="'+cities[i].id+'">'+cities[i].name+'</option>');
			}
        },
    };

    if ($('#order-guest-form').length) {
        orderGuest.init();
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/order-guest.js